// Add your custom JS here.
//

'use strict';

//
// Search click
//
if ( typeof jQuery !== 'undefined' ) {
	jQuery(
		function( $ ) {
			$( '.ic-search' ).click(
				function(e) {
					e.preventDefault();
					$( '#search-overlay' ).modal( 'show' );
					$( '#search-overlay .form-control' ).val( '' );
					setTimeout(
						function () {
							$( '#search-overlay .form-control' ).focus();
						},
						1000
					);
				}
			);

			$( '.dwc--link-search' ).click(
				function (e) {
					e.preventDefault();
					$( '#search-overlay' ).modal( 'show' );
					$( '#search-overlay .form-control' ).val( '' );
					setTimeout(
						function () {
							$( '#search-overlay .form-control' ).focus();
						},
						1000
					);
				}
			);

			//
			// Show/Hide Navbar mobile collapse line
			//
			$( '.navbar-toggler' ).click(
				function () {
					$( '#wrapper-navbar' ).toggleClass( 'd--border-bottom-1' );
				}
			);
		}
	);
}

/**
 * Auto update price on card page after quantity change
 *
 * See: https://rudrastyh.com/woocommerce/remove-update-cart-button.html
 *
 * Optionally also hide button:
 * .woocommerce button[name="update_cart"],
 * .woocommerce input[name="update_cart"] {
 *     display: none;
 * }
 */
var timeout;

jQuery(
	function( $) {
		$( '.woocommerce' ).on(
			'change',
			'input.qty',
			function () {
				//console.log( 'Quantity changed...' );

				if (timeout !== undefined) {
					clearTimeout( timeout );
				}

				timeout = setTimeout(
					function () {
						$( "[name='update_cart']" ).trigger( 'click' );
					},
					800
				); // 1 second delay, half a second (500) seems comfortable too
			}
		);
	}
);

/**
 * Update add to card button value
 */
jQuery(
	function( $) {
		window.label           = $( '.button.btn-cart-product' ).text();
		window.separator       = ' — ';
		window.labelStr        = '';
		window.labelValuePrice = 0;
		window.labelValueUnit = 'CHF';

		// ('BASE: ' + window.labelValuePrice);

		/**
		 * Set default values
		 *
		 * @return {[type]} [description]
		 */
		function getButtonLabel() {
			// console.log('***getButtonLabel***');
			if (window.label) {
				// console.log('window.label: ' + window.label);
				// console.log('window.separator: ' + window.separator);

				var labelArr = window.label.split(window.separator);

				// console.log('labelArr: ' + labelArr);

				window.labelStr   = labelArr[0];
				var labelValue    = labelArr[1];

				if (labelValue !== undefined) {
					var match = labelValue.match(/^([^\d]+)\s*([\d.,]+)/);
					if (match) {
						window.labelValueUnit = match[1].trim();
						window.labelValuePrice = parseFloat(match[2].replace(',', '.'));
					} else {
						var labelValueArr = labelValue.split(/\s+/);
						window.labelValueUnit = labelValueArr[0];
						window.labelValuePrice = parseFloat(labelValueArr[1]);
					}
				}

				// console.log('getButtonLabel: ' + window.labelValuePrice);
			}
		}
		/**
		 * Update button text
		 *
		 * @param {[type]} val  [description]
		 */
		function setButtonLabel(val) {
			// console.log('***setButtonLabel***');
			//console.log('setButtonLabel: ' + val + ' / ' + window.labelValuePrice);

			if (window.labelValuePrice != 0) {
				var price = Number(window.labelValuePrice) * Number(val);

				price   = price.toFixed( 2 );
				var str = window.labelStr + window.separator + window.labelValueUnit + ' ' + price;

				$( 'button.btn-cart-product' ).text( str );
			}
		}

		// On input changed
		$('input.numeric-stepper').blur(
			function () {
				// console.log('***input.numeric-stepper***');
				var val = parseFloat( $( 'input.numeric-stepper' ).val() );

				if (val > 10) {
					val = 10;
				} else if (val < 1) {
					val = 1;
				}

				if (window.labelStr === '' ) {
					getButtonLabel();
				}

				setButtonLabel( val );

				$( 'input.numeric-stepper' ).val( val );
			}
		);

		// On number stepper changed
		$( '.btn-numeric-stepper' ).on(
			'click tap',
			function (e) {
				// console.log('***btn-numeric-stepper***');

				var $button = $( this );

				var $input = $( $button )
				.closest( '.form-group-stepper' )
				.find( 'input.numeric-stepper' );

				var oldValue = $($input).val();
				// console.log('oldValue: ' + oldValue);

				// Max value reached
				if ( $( $button ).hasClass( 'btn-plus' ) ) {
					if (parseFloat( oldValue ) === 10) {
						return;
					}
					var newVal = parseFloat( oldValue ) + 1;
				} else {
					// Don't allow decrementing below one
					if (oldValue > 1) {
						var newVal = parseFloat( oldValue ) - 1;
					} else {
						newVal = 1;
					}
				}

				// console.log('newVal: ' + newVal);

				if (window.labelStr === '') {
					// console.log('window.labelStr = empty');
					getButtonLabel();
				}

				setButtonLabel( newVal );

				// $( 'input.numeric-stepper' ).val(newVal);
				$( $input ).val( newVal );

				// On cart page
				$( "[name='update_cart']" ).prop( 'disabled', false );
				$( "[name='update_cart']" ).attr( 'aria-disabled', 'false' );
				$( "[name='update_cart']" ).trigger( 'click' );
			}
		);

		// On radio variant changed
		$( '.woovr-variation' ).on(
			'click tap',
			function () {
				// console.log('***woovr-variation***');

				var $radio = $( this );
				var price  = $( $radio ).data( 'price' );
				var num    = parseFloat( $( 'input.numeric-stepper' ).val() );

				if (window.labelStr === '' ) {
						getButtonLabel();
				}

				window.labelValuePrice = price;
				setButtonLabel( num );

				// Enable button and trigger WooCommerce variation check
				// This ensures the button is enabled when a radio variation is selected
				$( 'button.btn-cart-product' ).prop( 'disabled', false ).removeClass( 'disabled' ).attr( 'aria-disabled', 'false' );
				$( this ).closest( 'form.variations_form' ).trigger( 'check_variations' );
			}
		);

		// On variation found, explicitly enable the button
		// This handles cases where WooCommerce core JS might still keep it disabled
		$( '.variations_form' ).on(
		        'found_variation',
		        function() {
		                $( 'button.btn-cart-product' ).prop( 'disabled', false ).removeClass( 'disabled' ).attr( 'aria-disabled', 'false' );
		        }
		);

		// Auto-select first variation if none is selected
		// This ensures the button is active by default
		if ( $( '.woovr-variation' ).length > 0 && $( '.woovr-variation-active' ).length === 0 ) {
		        var $firstVariation = $( '.woovr-variation' ).filter( function() {
		                return $( this ).data( 'id' ) > 0;
		        }).first();

		        if ( $firstVariation.length > 0 ) {
		                $firstVariation.trigger( 'click' );
		        }
		}
		}
		);
/**
 * Cart coupon code
 */
jQuery(
	function( $) {
		// Copy the added coupon code to WooCommerce hidden default coupon field
		$( '.coupon.under-proceed #coupon_code_new' ).on(
			'input',
			function() {
				$( 'form.woocommerce-cart-form input[name="coupon_code"]' ).val(
					$( this ).val()
				);
				// console.log( 'Val: ' + $(this).val() ); // Uncomment for testing
			}
		);

		// On button click, submit WooCommerce hidden default coupon form
		$( '.coupon.under-proceed .btn' ).on(
			'click',
			function () {
				$( 'button[name="apply_coupon"]' ).trigger( 'click' );
			}
		);
	}
);

/**
 * Show / hide signin / signup
 */
jQuery(
	function ( $) {
		function setAuthForm(val) {
			$( '.alert-danger' ).hide();
			$( '#form-login' ).removeClass( 'was-validated' );
			$( '#form-register' ).removeClass( 'was-validated' );

			// Reset values
			$( '#form-login input#username' ).val( '' );
			$( '#form-login input#password' ).val( '' );
			$( '#form-register input#reg_billing_first_name' ).val( '' );
			$( '#form-register input#reg_billing_last_name' ).val( '' );
			$( '#form-register input#reg_email' ).val( '' );
			$( '#form-register input#reg_password' ).val( '' );

			// Login
			$( '#form-login input#username' ).prop( 'required', false );
			$( '#form-login input#password' ).prop( 'required', false );

			// Signup
			$( '#form-register input#reg_billing_first_name' ).prop( 'required', false );
			$( '#form-register input#reg_billing_last_name' ).prop( 'required', false );
			$( '#form-register input#reg_email' ).prop( 'required', false );
			$( '#form-register input#reg_password' ).prop( 'required', false );
			$( '#form-register input#terms' ).prop( 'required', false );

			if (val === 'signin' ) {
				$( '#form-login input#username' ).prop( 'required', true );
				$( '#form-login input#password' ).prop( 'required', true );

				$( '.woocommerce-form-register' ).hide();
				$( '.woocommerce-form-login' ).show();
			} else {
				$( '#form-register input#reg_billing_first_name' ).prop( 'required', true );
				$( '#form-register input#reg_billing_last_name' ).prop( 'required', true );
				$( '#form-register input#reg_email' ).prop( 'required', true );
				$( '#form-register input#reg_password' ).prop( 'required', true );
				$( '#form-register input#terms' ).prop( 'required', true );

				$( '.woocommerce-form-login' ).hide();
				$( '.woocommerce-form-register' ).show();
			}
		}
		setAuthForm( 'signin' );

		$( 'input[type=radio][name=rbAuth]' ).change(
			function () {
				setAuthForm( this.value );
			}
		);

		$( '#rbAuthSignin' ).prop( 'checked', true );
	}
);

/**
 * Contact form
 */
jQuery(
	function ( $) {
		$( '#form-contact #inputTopic' ).change(
			function() {
				$( '#dwc--input-group-order-number' ).show();
				$( '#dwc--input-group-file' ).show();

				switch ( $( this ).val() ) {
					case 'feedback':
						$( '#dwc--input-group-order-number' ).hide();
						$( '#dwc--input-group-order-number input' ).val( '' );
						break;
					case 'press':
					case 'partnerships':
					case 'other':
						$( '#dwc--input-group-order-number' ).hide();
						$( '#dwc--input-group-order-number input' ).val( '' );
						$( '#dwc--input-group-file' ).hide();
						$( '#dwc--input-group-file input' ).val( '' );
						break;
					default:
						// code block
				}
			}
		);
	}
);

/**
 * Overwrite hide notification bar
 */
jQuery( ".njt-nofi-container .njt-nofi-close-button" ).on(
	"click",
	function (e) {
		setTimeout(
			function () {
				var d = Math.floor( Date.now() / 1000 ) + 30 * 24 * 60 * 60;
				try {
					// May be undefined
					if (homeNotificationBar !== undefined) {
						homeNotificationBar.setCookie( 'njt-close-notibar', 'true', 30 ); // 30 == days
						homeNotificationBar.setCookie( 'njt-close-notibar-date', d, 30 );
					}
				} catch (error) {
					// console.log(error);
				}
			},
			1000
		);
	}
);

/**
 * Show country info if user is NOT in Switzerland
 */
/*
function setCountryMessage() {
	var msg = 'Unfortunately, we don`t ship to <b>' + window.str_country_name + '</b> at the moment. Please contact us if you need any help!';
	switch (window.str_language) {
		case 'de':
			msg = 'Leider liefern wir im Moment nicht nach <b>' + window.str_country_name + '</b>.  Bitte kontaktieren Sie uns, wenn Sie Hilfe benötigen!';
			break;
		case 'fr':
			msg = 'Malheureusement, nous ne livrons pas encore en <b>' + window.str_country_name + '</b>. N`hésitez pas à nous contacter si vous avez besoin d`aide!';
			break;
	}
	jQuery( '.njt-nofi-container-content .njt-nofi-text' ).html(msg);

	// Hide close button (set style)
	setTimeout(function () {
		jQuery( '.njt-nofi-container-content .njt-nofi-close-button' ).css( 'display', 'none' );
	}, 500);
}

if (jQuery( '.njt-nofi-container-content .njt-nofi-padding-text' ).hasClass( 'njt-nofi-text' ) && (window.str_country_iso !== 'CH' ) ) {
	setCountryMessage();
} else if (window.str_country_iso !== 'CH' ) {
	// Remove njt-nofi cookie
	var d = Math.floor(Date.now() / 1000) - 30;
	try {
		// May be undefined
		homeNotificationBar.setCookie( 'njt-close-notibar', 'true', -1);
		homeNotificationBar.setCookie( 'njt-close-notibar-date', d, -1);
	} catch (error) {
		// console.log(error);
	}
	setCountryMessage();
}*/

/**
 * Show notice toast on "archive" page
 * if "add to cart" by ajax in WC settings is enabled.
 */
if ( typeof jQuery !== 'undefined' ) {
	jQuery( 'body' ).on(
		'added_to_cart',
		function () {
			// e, fragments, cart_hash, this_button
			jQuery( '.woocommerce-notices-wrapper' ).empty();
			// woocommerce_cart_item_removed
			var msg = '<div class="woocommerce-message d-none" role="alert">' + window.str_product_added_to_cart + ' <a href="' + window.str_url_cart + '">' + window.str_view_cart + '</a></div>';
			jQuery( '.woocommerce-notices-wrapper' ).append( msg );
		}
	);

	jQuery( 'body .ttt-pnwc-close' ).on(
		'click',
		function () {
			jQuery( '.woocommerce-notices-wrapper' ).empty();
		}
	);

	/*
	 * Disable manual entry/copy of numbers in numeric stepper
	 */
	jQuery( 'input.numeric-stepper' ).keypress(
		function (e) {
			e.preventDefault();
		}
	);

	// Disable context menu past
	jQuery( 'input.numeric-stepper' ).on(
		'contextmenu',
		function (e) {
			e.preventDefault();
			return false;
		}
	);

	// Disable cut, copy and paste
	jQuery( 'input.numeric-stepper' ).bind(
		'cut copy paste',
		function (e) {
			e.preventDefault();
		}
	);
}
